module.exports = __webpack_public_path__ + "media/images/home/occupation@2x-7aea5256474293ba3c4244697930160c.png";